import React, { useState, useEffect, useRef, useCallback } from "react";
import {
    Grid,
    Box,
    Paper,
    makeStyles,
    Tabs,
    Tab,
    TableContainer,
    Table,
    TableCell,
    TableRow,
    TableHead,
    TableBody,
    Switch,
    Typography,
    Button,
    TextField,
    Tooltip,

} from "@material-ui/core";
import { LuArrowDownUp, LuArrowUp, LuArrowDown } from "react-icons/lu";
import SaveIcon from '@material-ui/icons/Save';
import * as actions from "./actions";
import moment from "moment";
import DeleteIcon from "@material-ui/icons/Delete";
import { getCurrentUserId, getCurrentUserOrganizationId, getObject, toastError, toastSuccess } from "../../../utils";
import CustomPagination from "../../../components/Common/CustomPagination";
import CustomConfirmModal from "../../../components/Common/CustomConfirmModal";
import ShareIcon from '@material-ui/icons/Share';
import ShareWithOrg from "../../../components/Common/ShareWithOrg";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import { createVesselVessel } from "../Calculator/actions";
import CustomTooltip from "../../../common/Tooltip";
import SearchBar from "../../../common/Search";
import _ from "lodash";
import { use } from "react";
import { updateUser } from "../Dashboard/actions";
import CustomTabs from "../../../common/Tabs";

const useStyles = makeStyles({
    root: {
        width: "fit-content",
    },
});

const initialSearchType = {
    type: "",
    saveLabel: "",
    name: "",
    firstLoadPort: "",
    lastDischargePort: "",
    loadQuantity: "",
    createdDate: "",
};

function VesselVesselMatrix(props) {
    const { loader = false, setLoader = () => { } } = props;
    const classes = useStyles();

    const [value, setValue] = useState(1);
    const [open, setOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [savedResults, setSavedResults] = useState([]);
    const [allSavedResults, setAllSavedResults] = useState([]);

    const [hasFetchedUser, setHasFetchedUser] = useState(false);
    const [hasFetchedOrg, setHasFetchedOrg] = useState(false);

    const [searchType, setSearchType] = useState({ ...initialSearchType });

    const [myFilters, setMyFilters] = useState({
        offset: 1,
        limit: 50,
        sortBy: "createdDate",
        sortDirection: "desc",
    });
    const [allFilters, setAllFilters] = useState({
        offset: 1,
        limit: 50,
        sortBy: "createdDate",
        sortDirection: "desc",
    });

    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState({});

    const [isShareConfirm, setShareConfirm] = useState(false);
    const [getSingleCargoData, setSingleCargoData] = useState("");
    const [shareLabel, setShareLabel] = useState("");

    const [getSingleVoyagesData, setSingleVoyagesData] = useState("");
    const [isCopyConfirm, setCopyConfirm] = useState(false);

    const organizationId = getCurrentUserOrganizationId();
    // const addDetailsModalRef = useRef();

    const [searchValue, setSearchValue] = useState("");
    const user = getObject("auth");
    const [reason, setReason] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (reason === "") {
            toastError("Please write a reason");
            return
        }
        const requestData = {
            reason: reason,
            section: 'Vessel Matrix',
            createdAt: new Date().toISOString(),
        };

        updateUser({ request: requestData })
            .then((res) => {
                toastSuccess('Request submited successfully');
                setReason("");
            })
            .catch((err) => {
                console.error('Error updating user details:', err);
                toastError('Error updating user details');
            });
    };


    const onSearchVessel = (search) => {
        getAllSavedResults(search);
        getAllOrgSavedResults(search);
    };
    const delaySearch = useCallback(
        _.debounce((data) => onSearchVessel(data), 500),
        []
    );
    const onSearchChange = (e) => {
        setSearchValue(e.target.value)
        delaySearch(e.target.value);
    }

    useEffect(() => {
        if (value === 1 && !hasFetchedUser) {
            getAllSavedResults();
        } else if (value === 2 && !hasFetchedOrg) {
            getAllOrgSavedResults();
        }
    }, [value]);

    const getAllSavedResults = async (search, filters) => {
        const currentFilters = filters || myFilters;
        setLoader(true);
        await actions
            .getVesselVesselDetails({ userId: getCurrentUserId(), search: search, ...currentFilters })
            .then((res) => {
                setLoader(false);
                setHasFetchedUser(true);
                setSavedResults(res?.data?.list || []);
                setMyFilters((prev) => ({
                    ...prev,
                    ...currentFilters,
                    totalPages: res?.data?.totalItems,
                    offset: res?.data?.currentPage,
                    pageCount: res?.data?.totalPages,
                    limit: res?.data?.perPage
                }))
            })
            .catch((err) => {
                setLoader(false);
                setHasFetchedUser(true);
                toastError(err?.data?.message);
            });
    };

    const getAllOrgSavedResults = async (search, filters) => {
        const currentFilters = filters || allFilters;
        setLoader(true);
        await actions
            .getVesselVesselDetails({ organizationId: organizationId, search: search, ...currentFilters })
            .then((res) => {
                setLoader(false);
                setHasFetchedOrg(true);
                setAllSavedResults(res?.data?.list || []);
                setAllFilters((prev) => ({
                    ...prev,
                    ...currentFilters,
                    totalPages: res?.data?.totalItems,
                    offset: res?.data?.currentPage,
                    pageCount: res?.data?.totalPages,
                    limit: res?.data?.perPage
                }))
            })
            .catch((err) => {
                setLoader(false);
                setHasFetchedOrg(true);
                toastError(err?.data?.message);
            });
    };

    const handleSortClick = (sortKey, isAll) => {
        const currentFilters = isAll ? allFilters : myFilters;
        let newSortDirection = "asc";

        if (currentFilters.sortBy === sortKey) {
            if (currentFilters.sortDirection === "asc") newSortDirection = "desc";
            else if (currentFilters.sortDirection === "desc") {
                newSortDirection = sortKey === "createdDate" ? "asc" : "";
            }
        } else {
            newSortDirection = sortKey === "createdDate" ? "desc" : "asc";
        }

        let apiFilters = { ...currentFilters, sortBy: sortKey, sortDirection: newSortDirection, offset: 1 };
        if (!newSortDirection) {
            apiFilters.sortBy = "createdDate";
            apiFilters.sortDirection = "desc";
        }

        if (isAll) {
            getAllOrgSavedResults(searchValue, apiFilters);
        } else {
            getAllSavedResults(searchValue, apiFilters);
        }
    };


    const handleChange = (event, newValue) => {
        setValue(newValue);
        setSearchType({ ...initialSearchType });
    };

    const onClickDeletAddress = (id) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    const onDeleteAddress = () => {
        setLoader(true);
        actions
            .deleteVesselVessel(deleteId)
            .then((res) => {
                toastSuccess("Result deleted successfully");
                setDeleteModal(false);
                setDeleteId("");
                getAllSavedResults();
            })
            .catch((err) => {
                toastError();
                setLoader(false);
            });

    }


    const onChangeMyPagination = (type = "") => {
        let newMyFilters = {};
        if (type === "inc") {
            newMyFilters = { ...myFilters, offset: myFilters.offset + 1 };
        } else if (type === "first") {
            newMyFilters = { ...myFilters, offset: 1 };
        } else {
            if (myFilters.offset === 1) return;
            newMyFilters = { ...myFilters, offset: myFilters.offset - 1 };
        }
        setLoader(true);
        getAllSavedResults(searchValue, { ...myFilters, offset: newMyFilters.offset })
    };

    const onChangeAllPagination = (type = "") => {
        let newAllFilters = {};
        if (type === "inc") {
            newAllFilters = { ...allFilters, offset: allFilters.offset + 1 };
        } else if (type === "first") {
            newAllFilters = { ...allFilters, offset: 1 };
        } else {
            if (allFilters.offset === 1) return;
            newAllFilters = { ...allFilters, offset: allFilters.offset - 1 };
        }
        setLoader(true);
        getAllOrgSavedResults(searchValue, { ...allFilters, offset: newAllFilters.offset });
    };

    // const onDeleteAddress = () => {
    //     setLoader(true);
    //     actions
    //         .deleteAddressDetails(deleteId)
    //         .then((res) => {
    //             toastSuccess("Result deleted successfully");
    //             setDeleteModal(false);
    //             setDeleteId("");
    //             getAllSavedResults();
    //         })
    //         .catch((err) => {
    //             toastError();
    //             setLoader(false);
    //         });
    // };

    const onShareOrgSaveClick = async () => {
        if (!organizationId) {
            toastError("You are not part of any organization!");
            return
        }
        if (!shareLabel || !getSingleCargoData) return
        
        try {
            setLoader(true);
            const res = await actions.getSingleVesselVesselDetails(getSingleCargoData._id);
            if (!res?.data) {
                setLoader(false);
                return toastError("Failed to fetch vessel details");
            }

            let { _id, ...data } = res.data;
            data.access = "public"
            data.organizationId = organizationId
            data.vesselVesselLabel = shareLabel
            // data.userId = null

            await actions.addTeamVesselVesselDetails(data)

            setShareConfirm(false)
            setShareLabel("")
            getAllOrgSavedResults()
        } catch (error) {
            setLoader(false);
            toastError(error?.data?.message || "Error sharing vessel");
        }
    }
    const onShareOrgClick = (item) => {
        setShareConfirm(!isShareConfirm)
        setSingleCargoData(item ? item : "")
        setShareLabel("")
    }

    const onCopyClick = (item) => {
        setCopyConfirm(!isCopyConfirm)
        setSingleVoyagesData(item ? item : "")
        setShareLabel("")
    }

    const onCopySaveClick = async () => {
        if (!shareLabel || !getSingleVoyagesData || !organizationId) return
        
        try {
            setLoader(true);
            const res = await actions.getSingleVesselVesselDetails(getSingleVoyagesData._id);
            if (!res?.data) {
                setLoader(false);
                return toastError("Failed to fetch vessel details");
            }

            let { _id, ...data } = res.data;
            data.access = "private"
            data.organizationId = organizationId
            data.userId = getCurrentUserId()
            data.vesselVesselLabel = shareLabel
            await createVesselVessel(data);

            setCopyConfirm(false)
            setShareLabel("")
            getAllSavedResults()
        } catch (error) {
            setLoader(false);
            toastError(error?.data?.message || "Error copying vessel");
        }
    }
    const handleDateRangeChange = async (newDateRange) => {
        const { startDate, endDate } = newDateRange;

        // Ensure dates are in ISO string format
        const formattedStartDate = startDate?.toISOString() || '';
        const formattedEndDate = endDate?.toISOString() || '';

        if (value === 2) {
            const { data } = await actions.getAllVesselVesselDetails({
                startDate: formattedStartDate,
                organizationId: organizationId,
                endDate: formattedEndDate
            });
            setAllSavedResults(data?.list);
        } else {
            const { data } = await actions.getVesselVesselDetails({
                userId: getCurrentUserId(),
                startDate: formattedStartDate,
                endDate: formattedEndDate
            });
            setSavedResults(data?.list);
        }
    };

    const tabs = [
        { label: "My Vessel", key: 1, tooltip: "Displays vessel estimation entries created by you." },
        { label: "Fleet List", key: 2, tooltip: "Displays vessel estimation entries created by other users." },
    ];

    return (
        <Grid container alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
            <Grid item xs={12}>
                <Box
                    display="flex"
                    alignItems="center"
                    position="relative"
                    width="100%"
                >
                    <Box>
                        <CustomTabs tabs={tabs} active={value} onChange={handleChange} />
                    </Box>

                    <Box
                        position="absolute"
                        left="50%"
                        sx={{
                            transform: 'translateX(-50%)',
                            display: { xs: 'none', md: 'block' } // Desktop view
                        }}
                    >
                        <div className="desktop-searchbar">
                            <SearchBar
                                onDateRangeChange={handleDateRangeChange}
                                placeholder={"Search with Vessel Name or Port..."}
                                setSearchValue={onSearchChange}
                                searchValue={searchValue}
                            />
                        </div>
                    </Box>


                </Box>

                {/* Mobile search bar */}
                <Box
                    className="md:hidden"
                    display="flex"
                    justifyContent="center"
                    mt={2}
                >
                    <div className="w-full"><SearchBar
                        isMobile
                        onDateRangeChange={handleDateRangeChange}
                        placeholder={"Search with Vessel Name or Port..."}
                        setSearchValue={onSearchChange}
                        searchValue={searchValue}
                    /></div>
                </Box>
            </Grid>

            <Grid item xs={12}></Grid>

            <Grid item xs={12}>
                {value === 1 ? <Box pt={2}>
                    <TableContainer component={Paper} style={{ minHeight: (loader || !savedResults?.length) ? "500px" : "auto", overflow: loader ? "hidden" : "auto" }}>
                        {myFilters?.totalPages > myFilters?.limit && (
                            <CustomPagination
                                onChangePagination={onChangeMyPagination}
                                filters={myFilters}
                                totalPage={myFilters?.totalPages}
                            />
                        )}
                        <Table className="universal-table w-full fit-content-mobile">
                            <TableHead className="bg-[#103f6b]">
                                <TableRow className="h-6">
                                    <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">No.</TableCell>
                                    <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap cursor-pointer" onClick={() => handleSortClick("name", false)}>
                                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                            Name
                                            <div style={{ color: myFilters.sortBy === "name" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                                                {myFilters.sortBy === "name" && myFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : myFilters.sortBy === "name" && myFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">Vessel Name</TableCell>
                                    <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">DWT</TableCell>
                                    <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">Port</TableCell>
                                    <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">Customer</TableCell>
                                    <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">Vendor</TableCell>
                                    <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap cursor-pointer" onClick={() => handleSortClick("createdDate", false)}>
                                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                            Created on
                                            <div style={{ color: myFilters.sortBy === "createdDate" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                                                {myFilters.sortBy === "createdDate" && myFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : myFilters.sortBy === "createdDate" && myFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">Created By</TableCell>
                                    <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium whitespace-nowrap text-center" style={{ width: 90 }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loader ? (
                                    <TableRow>
                                        <TableCell colSpan={10} align="center" className="!bg-white">
                                            <Box display="flex" justifyContent="center" alignItems="center" height="440px">

                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ) : Array.isArray(savedResults) && savedResults.length ? (
                                    savedResults.map((item, index) => {
                                        return <TableRow
                                            className="h-6 hover:bg-gray-50 cursor-pointer"
                                            key={index}
                                            onDoubleClick={() => window.open(`/vessel-vessel/estimation/${item._id}`, "_blank")}
                                        >
                                            <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">{(myFilters.offset - 1) * myFilters.limit + index + 1}</TableCell>
                                            <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">

                                                <a
                                                    style={{ color: "blue" }}
                                                    href={`/vessel-vessel/estimation/${item._id}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {item?.vesselVesselLabel || ""}
                                                </a>
                                            </TableCell>
                                            <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">
                                                {item?.vesselName || ""}
                                            </TableCell>
                                            <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">
                                                {item?.dwt || 0}
                                            </TableCell>
                                            <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">
                                                {item?.port || ""}
                                            </TableCell>
                                            <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">{item?.clientQuery?.Tag1?.name || item?.Tag1?.name}</TableCell>
                                            <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">{item?.clientQuery?.Tag2?.name || item?.Tag2?.name}</TableCell>
                                            <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">{moment(item?.createdDate).format("DD/MMM/yyyy")}</TableCell>
                                            <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">{item?.createdUserName || ''}</TableCell>

                                            <TableCell className="!py-0.5 !px-2 text-[11px] font-medium text-center">
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                                                    <CustomTooltip position="top" text="Share with your Team">
                                                        <ShareIcon
                                                            color="primary"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => onShareOrgClick(item)}
                                                        />
                                                    </CustomTooltip>
                                                    <CustomTooltip position="top" text="Delete">
                                                        <DeleteIcon
                                                            color="secondary"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => onClickDeletAddress(item?._id)}
                                                        />
                                                    </CustomTooltip>
                                                </div>
                                            </TableCell>
                                        </TableRow>

                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell
                                            colSpan={10}
                                            align="center"
                                            className="!bg-white"
                                        >
                                            No Vessel Details Found.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        {myFilters?.totalPages > myFilters?.limit && (
                            <CustomPagination
                                onChangePagination={onChangeMyPagination}
                                filters={myFilters}
                                totalPage={myFilters?.totalPages}
                            />
                        )}
                    </TableContainer>
                </Box>
                    : <Box pt={2}>
                        <TableContainer component={Paper} style={{ minHeight: (loader || !allSavedResults?.length) ? "500px" : "auto", overflow: loader ? "hidden" : "auto" }}>
                            {allFilters?.totalPages > allFilters?.limit && (
                                <CustomPagination
                                    onChangePagination={onChangeAllPagination}
                                    filters={allFilters}
                                    totalPage={allFilters?.totalPages}
                                />
                            )}
                            <Table className="universal-table w-full fit-content-mobile">
                                <TableHead className="bg-[#103f6b]">
                                    <TableRow className="h-6">
                                        <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">No.</TableCell>
                                        <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap cursor-pointer" onClick={() => handleSortClick("name", true)}>
                                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                                Name
                                                <div style={{ color: allFilters.sortBy === "name" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                                                    {allFilters.sortBy === "name" && allFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : allFilters.sortBy === "name" && allFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">Vessel Name</TableCell>
                                        <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">DWT</TableCell>
                                        <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">Port</TableCell>
                                        <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">Customer</TableCell>
                                        <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">Vendor</TableCell>
                                        <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap cursor-pointer" onClick={() => handleSortClick("createdDate", true)}>
                                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                                Created on
                                                <div style={{ color: allFilters.sortBy === "createdDate" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                                                    {allFilters.sortBy === "createdDate" && allFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : allFilters.sortBy === "createdDate" && allFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap">Created By</TableCell>
                                        <TableCell className="text-white !py-0.5 !px-2 text-[11px] font-medium whitespace-nowrap text-center" style={{ width: 90 }}>Action</TableCell>
                                    </TableRow>

                                </TableHead>
                                <TableBody>
                                    {loader ? (
                                        <TableRow>
                                            <TableCell colSpan={10} align="center" className="!bg-white">
                                                <Box display="flex" justifyContent="center" alignItems="center" height="440px">

                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ) : Array.isArray(allSavedResults) && allSavedResults.length ? (
                                        allSavedResults.map((item, index) => {
                                            return <TableRow
                                                className="h-6 hover:bg-gray-50 cursor-pointer"
                                                key={index}
                                                onDoubleClick={() => window.open(`/vessel-vessel/estimation/${item._id}`, "_blank")}
                                            >
                                                <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">{(allFilters.offset - 1) * allFilters.limit + index + 1}</TableCell>
                                                <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">

                                                    <a
                                                        style={{ color: "blue" }}
                                                        href={`/vessel-vessel/estimation/${item._id}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {item?.vesselVesselLabel || ""}
                                                    </a>
                                                </TableCell>
                                                <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">
                                                    {item?.vesselName || ""}
                                                </TableCell>
                                                <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">
                                                    {item?.dwt || 0}
                                                </TableCell>
                                                <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">
                                                    {item?.port || ""}
                                                </TableCell>
                                                <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">{item?.clientQuery?.Tag1?.name || item?.Tag1?.name}</TableCell>
                                                <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">{item?.clientQuery?.Tag2?.name || item?.Tag2?.name}</TableCell>
                                                <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">{moment(item?.createdDate).format("DD/MMM/yyyy")}</TableCell>
                                                <TableCell className="!py-0.5 !px-2 text-[11px] font-medium border-r border-gray-300">{item?.createdUserName || ''}</TableCell>

                                                <TableCell className="!py-0.5 !px-2 text-[11px] font-medium text-center">
                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                                                        <CustomTooltip position="top" text="Copy to My Vessel">
                                                            <SaveIcon
                                                                color="primary"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => onCopyClick(item)}
                                                            />
                                                        </CustomTooltip>
                                                    </div>
                                                </TableCell>
                                            </TableRow>

                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell
                                                colSpan={10}
                                                align="center"
                                                className="!bg-white"
                                            >
                                                No Vessel Details Found.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            {allFilters?.totalPages > allFilters?.limit && (
                                <CustomPagination
                                    onChangePagination={onChangeAllPagination}
                                    filters={allFilters}
                                    totalPage={allFilters?.totalPages}
                                />
                            )}
                        </TableContainer>
                    </Box>}
            </Grid>

            <CustomConfirmModal
                open={deleteModal}
                handleClose={() => setDeleteModal(false)}
                message="Are you sure you want to delete this vessel details?"
                onSubmitConfirm={onDeleteAddress}
                type="warning"
                confirmText="DELETE"
                cancelText="Cancel"
                note="This action cannot be undone."
            />
            <CustomAddModal
                open={isShareConfirm}
                handleClose={onShareOrgClick}
                onSubmitConfirm={onShareOrgSaveClick}
                maxWidth="xs"
                saveLabel="Share"
                title="Share with Team"
            >
                <ShareWithOrg
                    value={shareLabel}
                    onChange={(e) => setShareLabel(e.target.value)}
                    placeholder="Enter VesselVessel name*"
                    label="Team copy name"
                    guidanceTitle="Share this vessel estimate"
                    guidance="Create a team copy of this vessel estimate. Your team can find it in Vessel Vessel Estimation → Fleet List."
                />
            </CustomAddModal>


            <CustomAddModal
                open={isCopyConfirm}
                handleClose={onCopyClick}
                onSubmitConfirm={onCopySaveClick}
                maxWidth="xs"
                saveLabel="Create"
                title="Copy to My Vessel"
            >
                <ShareWithOrg
                    value={shareLabel}
                    onChange={(e) => setShareLabel(e.target.value)}
                    placeholder="Enter Vessel Label*"
                    label="My copy name"
                    guidanceTitle="Copy this vessel estimate"
                    guidance="Create a separate personal copy of this shared vessel estimate. Find it in Vessel Vessel Estimation → My Vessel."
                />
            </CustomAddModal>
        </Grid>
    );
}

export default VesselVesselMatrix;
